import React, {useEffect, useState} from 'react'
import {Arc, Path, Text, TextPath, Transformer} from "react-konva";
import {parseInt} from "lodash";
import {BLOCK_SNAP_SIZE} from "../../../constants/design.constant";

const TextPathShape = ({
                           shapeProps,
                           isSelected,
                           onSelect,
                           onChange,
                           transformerRef,
                           handleGuidelineDragEnd,
                           handleGuidelineDragMove
                       }) => {
    const shapeRef = React.useRef();
    const arcShapeRef = React.useRef();
    const trRef = React.useRef();
    const [refreshShape, setRefreshShape] = useState(false);
    const [textPathData, setTextPathData] = useState(null);

    const handleTransformEnd = (event) => {
        const node = shapeRef.current || undefined;

        const scaleX = node.scaleX();
        const scaleY = node.scaleY();
        node.scaleX(1);
        node.scaleY(1);

        // textPath.getTextWidth() + (textPath.text().length - 1) * letterSpacing;

        /*const width = parseInt(String(Math.max(5, (node.getTextWidth() * scaleX) + 10 + ((node.text().length - 1) * node.letterSpacing()))));
        const height = parseInt(String(Math.max(5, (node.height() * scaleY) + 10)));*/

        const width = parseInt(String(Math.max(5, (node.textWidth) + 10)));
        const height = parseInt(String(Math.max(5, (node.textHeight) + 10)));

        processTextPathData(event);

        // console.log({shapeProps});
        /* console.log('letterSpacing: ', ((node.text().length - 1) * node.letterSpacing()));*/

        onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            fontSize: parseInt(String(Math.max(node.fontSize() * scaleX))),
            totalWidth: width,
            totalHeight: height,
            width: width,
            height: height,
            data: node.data(),
            rotation: node.rotation(),
        });
    }

    const handleDragEnd = (event) => {
        const node = shapeRef.current || undefined;

        const currentTextRef = event.target;
        currentTextRef.position({
            x: Math.round(currentTextRef.x() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE,
            y: Math.round(currentTextRef.y() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE
        });

        processTextPathData(event);

        const updatedAttrs = {
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            totalWidth: node.textWidth,
            totalHeight: node.textHeight,
            data: node.data()
        };

        onChange(updatedAttrs);
    }

    const processTextPathData = (e) => {
        const node = shapeRef.current || undefined;
        setTextPathData(node.data());
    }

    return (
        <>
            {/*<Path
                x={shapeProps?.x}
                y={shapeProps?.y}
                rotation={shapeProps?.rotation}
                stroke={shapeProps?.fill}
                strokeWidth={20}
                data={textPathData}
            />*/}

            {/*<Arc
                ref={arcShapeRef}
                x={shapeProps?.x}
                y={shapeProps?.y}
                innerRadius={shapeProps?.radius}
                outerRadius={shapeProps?.totalHeight}
                angle={shapeProps?.startAngle}
                rotation={-shapeProps?.rotation}
                fill="yellow"
                stroke="black"
            />*/}

            <TextPath
                ref={shapeRef}
                {...shapeProps}
                name={'object'}
                draggable
                onTransformEnd={handleTransformEnd}
                onDragMove={(e) => {
                    handleDragEnd(e);
                    handleGuidelineDragMove(e);
                }}
                onDragEnd={(e) => {
                    handleDragEnd(e);
                    handleGuidelineDragEnd(e);
                }}
            />

            {/*{(isSelected) && (
                <Transformer
                    ref={trRef}
                    boundBoxFunc={(oldBox, newBox) => {
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                        return newBox;
                    }}
                />
            )}*/}

        </>
    )
}

export default TextPathShape
